
import Vue from "vue";
import { startCase } from "lodash";
import { headersInterface } from "@/interfaces/Tables.interfaces";
import { formatInTimeZone } from "@/helpers";
import {
  cancelJobHygienist,
  getCancelledByJobId,
  getHygienistShifts,
  moveHygienistCancelled
} from "@/api";
import { constants } from "@/utils/constants";
import { mapMutations } from "vuex";

interface Item {
  HygienistId: number;
  JobId: number;
}

export default Vue.extend({
  name: "ShiftsInDialog",
  props: {
    obj: Object
  },
  data: () => {
    return {
      tableData: [] as any,
      dataLoading: true,
      currentItem: {} as any,
      noteDialog: false,
      note: ""
    };
  },
  computed: {
    tableHeaders(): Array<headersInterface> {
      const tableColumns = constants.tableInDialog.shiftsInFSB;
      const data = tableColumns.map((i: string) => {
        return {
          align: "left",
          text: startCase(i === "id" ? "jobId" : i),
          value: i
        };
      });
      return [...data, { align: "left", text: "Actions", value: "actions" }];
    }
  },
  methods: {
    ...mapMutations(["callSnackbar"]),

    async dataRequest(item: Item): Promise<void> {
      try {
        const data = await getHygienistShifts(item.HygienistId, item.JobId);
        data.map(i => {
          if (i.startDate) {
            i.startDate = formatInTimeZone(i.startDate, "MMM dd, yyyy", "UTC");
          }
        });
        this.tableData = data;
      } catch (error) {
        console.error(error);
      } finally {
        this.dataLoading = false;
      }
    },

    openNoteDialog(item: Item) {
      this.noteDialog = true;
      this.currentItem = item;
      this.note = "";
    },

    async cancelItem() {
      const item = this.currentItem;
      try {
        await cancelJobHygienist(item.hygienistId, item.id, this.note);

        const job = await getCancelledByJobId(item.id);
        await moveHygienistCancelled({
          job,
          hygId: item.hygienistId
        });

        const data = await getHygienistShifts(item.hygienistId, item.id);
        data.map(i => {
          if (i.startDate) {
            i.startDate = formatInTimeZone(i.startDate, "MMM dd, yyyy", "UTC");
          }
        });
        this.tableData = data;

        this.callSnackbar({
          visible: true,
          text: "Shift was cancelled successfully",
          color: "green darken-2"
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.noteDialog = false;
      }
    }
  }
});
